module.exports = __webpack_public_path__ + "static/media/checkedlight.4cfb64e3.svg";